/* ============================================================
   Collections list — arrow controls for the horizontal drawers
   The tracks scroll natively (overflow-x) but hide their scrollbar, so mouse
   users get prev/next buttons. Buttons appear only when a row overflows and
   hide at each end. Touch users keep swiping (arrows hidden via CSS).
   ============================================================ */
(function () {
  'use strict';

  const $ = (sel, root) => (root || document).querySelector(sel);
  const $$ = (sel, root) => Array.from((root || document).querySelectorAll(sel));

  function initWrap(wrap) {
    const track = $('[data-cl-track]', wrap);
    const prev = $('[data-cl-prev]', wrap);
    const next = $('[data-cl-next]', wrap);
    if (!track || !prev || !next) return;

    // Distance to move per click: as many whole cards as are fully visible
    // (keeps the snap alignment tidy), at least one card.
    const pageDistance = () => {
      const card = track.querySelector('li');
      const styles = getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 24;
      const cardW = card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
      const perView = Math.max(1, Math.floor(track.clientWidth / cardW));
      return perView * cardW;
    };

    const update = () => {
      const max = track.scrollWidth - track.clientWidth - 1;
      const scrollable = max > 0;
      prev.hidden = !scrollable || track.scrollLeft <= 0;
      next.hidden = !scrollable || track.scrollLeft >= max;
    };

    // Align the arrows to the vertical centre of the image, not the whole card
    // (image + text). Measured from the first card's media so it tracks any
    // aspect ratio and breakpoint.
    const positionArrows = () => {
      const media = track.querySelector('.cl-media');
      if (!media) return;
      const wrapTop = wrap.getBoundingClientRect().top;
      const mediaRect = media.getBoundingClientRect();
      const center = (mediaRect.top - wrapTop) + mediaRect.height / 2;
      if (center > 0) wrap.style.setProperty('--cl-arrow-top', center + 'px');
    };

    prev.addEventListener('click', () => track.scrollBy({ left: -pageDistance(), behavior: 'smooth' }));
    next.addEventListener('click', () => track.scrollBy({ left: pageDistance(), behavior: 'smooth' }));

    let ticking = false;
    track.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => { ticking = false; update(); });
    }, { passive: true });

    const refresh = () => { update(); positionArrows(); };

    window.addEventListener('resize', refresh, { passive: true });

    // Images load lazily and change scrollWidth; re-check when they arrive.
    $$('img', track).forEach((img) => {
      if (!img.complete) img.addEventListener('load', refresh, { once: true });
    });

    refresh();
  }

  function boot(root) {
    $$('[data-cl-wrap]', root || document).forEach(initWrap);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot());
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (e) => boot(e.target));
})();
